import { lazy } from 'react';

const KycResubmit = lazy(() => import(/* webpackChunkName: "kyc-resubmit" */ './KycResubmit'));

export default KycResubmit;
